// font.ts
import { AppState } from './font_types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: AppState = {
  font: [],
};

const fontSlice = createSlice({
  name: 'font',
  initialState,
  reducers: {
    setFont: (state, action: PayloadAction<{ header_size: string; text_size: string; disclaimer_size: string; sidebar_size: string; header_text: string; default_message: string; contact: string; email: string; disclaimer: string; text_color: string; header_text_color: string; body_bg_color: string; header_bg_color: string; input_bg: string; button_color: string; button_text_color: string; }>) => {
      state.font.push(action.payload);
    },
  },
});

export const { setFont } = fontSlice.actions;
export default fontSlice.reducer;
